import e from "./index60.js";
class c extends e {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(r, o, t) {
    super(r ?? "canceled", e.ERR_CANCELED, o, t), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
}
const s = c;
export {
  s as default
};
